export default __webpack_public_path__ + "static/media/shield.d2d40b99.svg";